import * as angular from 'angular';
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {ConfigurationProfilesAlertsService} from "./configuration-profiles-alerts.service";
import {AgentConfigurationProfilesRequestsService} from "./agent-configuration-profiles-requests.service";
import {AgentModel} from "../../agents/angular/models/agent.model";
import {AgentRequests} from "../../agents/services/agent-requests.service";
import {ConfirmDialogService} from "../../commons/services/confirm-dialog.service";
import {AgentType} from "../../agents/types/agent.type";
import {IQService} from "angular";

export class AgentConfigurationProfilesService {

  constructor(private bringozLoaderService: BringozLoaderService, private $log, private $q: IQService,
              private agentConfigurationProfilesRequestsService: AgentConfigurationProfilesRequestsService,
              private configurationProfilesAlertsService: ConfigurationProfilesAlertsService,
              private agentRequests: AgentRequests,
              private confirmDialogService: ConfirmDialogService) {
  }

  createAgentConfigurationProfile(configurationProfile) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.agentConfigurationProfilesRequestsService.createAgentProfile(configurationProfile)
        .then((newConfigurationProfile) => {
          this.configurationProfilesAlertsService.createSuccess();
          resolve(newConfigurationProfile);
        })
        .catch((error) => {
          this.$log.error(error);
          this.configurationProfilesAlertsService.createError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  assignAgentsToProfile(profileId: string, agentIds: string[]) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.agentConfigurationProfilesRequestsService.assignAgentsToProfile(profileId, agentIds)
        .then((agents: AgentModel[]) => {
          this.configurationProfilesAlertsService.updateAccountsSuccess();
          resolve(agents);
        })
        .catch((error) => {
          this.$log.error(error);
          this.configurationProfilesAlertsService.updateAccountsError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  getDefaultAgentProfile(agentTypes: AgentType[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.agentConfigurationProfilesRequestsService.getDefaultProfile(agentTypes)
      .then((defaultProfile) => {
        deferred.resolve(defaultProfile);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateOne(profile) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.agentConfigurationProfilesRequestsService.updateOne(profile)
        .then((updatedProfile) => {
          this.configurationProfilesAlertsService.updateSuccess();
          resolve(updatedProfile);
        })
        .catch((error) => {
          this.$log.error(error);
          this.configurationProfilesAlertsService.updateError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  updateAgentProfile(profile, agentId) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.agentRequests.updateOne(profile, agentId)
        .then((updatedProfile) => {
          this.configurationProfilesAlertsService.updateSuccess();
          resolve(updatedProfile);
        })
        .catch((error) => {
          this.$log.error(error);
          this.configurationProfilesAlertsService.updateError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  duplicateOne(configurationProfile) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.agentConfigurationProfilesRequestsService.createAgentProfile(configurationProfile)
        .then((newConfigurationProfile) => {
          this.configurationProfilesAlertsService.duplicateSuccess();
          resolve(newConfigurationProfile);
        })
        .catch((error) => {
          this.$log.error(error);
          this.configurationProfilesAlertsService.duplicateError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  deleteOne(profileId) {
    const text = 'Are you sure you want to remove this configuration profile?'
    return this.confirmDialogService.confirm('Remove Configuration Profile', text)
      .then(() => {
        return this.delete(profileId)
      })
  }

  private delete(profileId) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.agentConfigurationProfilesRequestsService.deleteOne(profileId)
        .then((removedProfile) => {
          this.configurationProfilesAlertsService.removeSuccess();
          resolve(removedProfile);
        })
        .catch((error) => {
          this.$log.error(error);
          if (error.code === 400408) {
            this.configurationProfilesAlertsService.removeUsedError();
          } else this.configurationProfilesAlertsService.removeError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }
}

angular
  .module('bringoz.admin.configuration-profiles')
  .service('agentConfigurationProfilesService', AgentConfigurationProfilesService);
